import { FairResultDto } from '@/api/generated';

/** As many as the backend takes in one request */
export const MAX_EMAILS = 500;

// Anything around an @ up to a separator: catches "Anna Nowak <anna@uni.pl>" and Excel columns alike
const EMAIL_LIKE = /[^\s,;<>"'()[\]]+@[^\s,;<>"'()[\]]+/g;

/**
 * The e-mail addresses in pasted text, each once regardless of letter case, in the order they appear;
 * whether they are valid is for the backend to tell
 */
export const parseEmails = (text: string): string[] => {
  const seen = new Set<string>();
  return (text.match(EMAIL_LIKE) ?? []).filter(email => {
    const key = email.toLowerCase();
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

export type FunnelStep = 'added' | 'quizFinished' | 'recommended' | 'registered';

export const FUNNEL_STEPS: FunnelStep[] = ['added', 'registered', 'quizFinished', 'recommended'];

/**
 * @return the share of the candidates added from the fair, 0 to 1
 */
export const shareOfAdded = (result: FairResultDto, step: FunnelStep): number =>
  result.added === 0 ? 0 : result[step] / result.added;
